import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { Colleague } from '../colleague-photo';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { AddColleagueRequest } from './addcolleaguerequest';
import { AddColleagueResponse } from './addcolleagueresponse';
import { ApiRequestService} from '../../shared/api-request-service';
import { MAT_ICON, TOAST_STATE, ToastmessageService } from '../../toastmessage/toastmessage.service';
import { TranslationService } from '../../translation/translation.service';
import { HttpError } from '../../shared/httperror';
import { UploadFileResponse } from '../../banners/uploadfileresponse';

@Component({
    selector: 'app-addcolleague',
    templateUrl: './addcolleague.component.html',
    styleUrls: ['./addcolleague.component.scss']
})
export class AddcolleagueComponent {

    colleague: Colleague = {};

    colleagueForm?: FormGroup;

    addCoverFile = false;

    @ViewChild('fileCoverInput') fileCoverInput!: ElementRef;
    fileCover: File | null = null;

    downloadFileUrl = '';

    fileBaseUrl = '';

    uploadFileUrl = '/admin/uploadFile';

    errorMessageCover = 'Kérem válassza a kollégához tartozó képet!';

    imageUrl = '';

    addColleagueUrl = '/admin/add-colleague';

    configuratorBaseUrl = '';

    maxFileSize = 5000000;

    constructor(public _router: Router,
        private _apiRequestService: ApiRequestService,
        @Inject('DOWNLOAD_FILE_URL') private _downloadFileUrl: string,
        private _toastMessageService: ToastmessageService,
        private _fb: FormBuilder,
        @Inject('FILE_MANAGER_URL') private _fileManagerUrl: string,
        @Inject('CONFIGURATOR_BASE_URL') private _configuratorBaseUrl: string,
        private _translateService: TranslationService) {
        this.downloadFileUrl = _downloadFileUrl;
        this.fileBaseUrl = _fileManagerUrl;
        this.configuratorBaseUrl = _configuratorBaseUrl;
        this.createColleagueForm();

    }

    onChange(event: Event) {
        const target = event.target as HTMLInputElement;
        this.fileCover = target.files![0];
        if (this.fileCover.name.split('.').pop() === 'jpg' || 'png' || 'JPEG' || 'jpeg') {
            this.addCoverFile = true;
        }
        else {
            this.addCoverFile = false;
            this._toastMessageService.displayToastMessage(TOAST_STATE.warning, 'Kérem ".jpg" vagy ".png" kiterjesztésű fájlt töltsön fel!', MAT_ICON.warning);
            this.dismissError();
        }


    }
    clearSelectedCoverFile() {
        this.fileCoverInput.nativeElement.value = null;
        this.addCoverFile = false;
    }

    addColleaguePart() {
        const addColleagueRequest: AddColleagueRequest = {
            colleague: this.colleague
        };

        this._apiRequestService
        .sendRequest<AddColleagueRequest, AddColleagueResponse>(this.configuratorBaseUrl, true, addColleagueRequest, true, this.addColleagueUrl)
        .pipe(
            catchError((error: HttpErrorResponse) => {
                return throwError(() => {
                    const httpError: HttpError = error.error as HttpError;

                    this._toastMessageService.displayToastMessage(TOAST_STATE.error, 'HttpError hiba!', MAT_ICON.error);
                    this.dismissError();

                });
            })
        )
        .subscribe((response: AddColleagueResponse) => {
            this._toastMessageService.displayToastMessage(TOAST_STATE.success, response.responseMessage!, MAT_ICON.success);
            this.dismissError();
        });
    }


    createColleagueForm() {
        this.colleagueForm = this._fb.group({
            name: ['', [Validators.required]],
            jobTitle: ['', [Validators.required]],
        });
    }

    collectColleagueData() {
        this.colleague = {
            name: this.colleagueForm?.controls['name'].value as string | undefined,
            jobTitle: this.colleagueForm?.controls['jobTitle'].value as string | undefined,
            imageUrl: this.imageUrl
        };


    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }


    addColleague() {
        this.canColleageBeInserted();

        this._apiRequestService
            .uploadFile(this.fileCover!, true, true, this.fileBaseUrl, this.uploadFileUrl)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const httpError: HttpError = error.error as HttpError;
                        this._toastMessageService.displayToastMessage(
                            TOAST_STATE.error,
                            this._translateService.translate('admin.unsuccessfulSave! ' + httpError.errorMessage),
                            MAT_ICON.error
                        );
                        this.dismissError();

                    });
                })
            )
            .subscribe((response) => {
                const uploadFileResponse = response as UploadFileResponse;

                this.imageUrl = uploadFileResponse.downloadUri as string;

                this.collectColleagueData();

                this.addColleaguePart();
            });
    }

    canColleageBeInserted() {
        if (!this.addCoverFile) {
            this._toastMessageService.displayToastMessage(TOAST_STATE.warning, this.errorMessageCover, MAT_ICON.warning);
            this.dismissError();
            return;
        }

        if (
            this.fileCover?.size! > this.maxFileSize
        ) {
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.error,
                this._translateService.translate('A maximum fájl korlát 5MB. Kérem ennél kisebb méretű fájlt töltsön fel!'),
                MAT_ICON.error
            );
            this.dismissError();
            return;
    }
}


}
